import { updateTimeStreamProject } from 'owa-timestream-store';
import type { ProjectId } from 'owa-timestream-types';

/**
 * Patches the currently selected project.
 * @param updates properties of an OutlookSpace to patch
 */
export default async function patchProjectTaskFolderId(
    projectId: ProjectId,
    tasksParentFolderId: string
): Promise<void> {
    const updates = { tasksParentFolderId };
    await updateTimeStreamProject(projectId, updates, true);
}
